<template>
	<div>
        <div v-show="parentShow">
            <Form :model="formItem" :label-width="100" inline>
                <Form-item label="项目名称">
                    <Input type="text" v-model="formItem.name"></Input>
                </Form-item>
                <Form-item>
                    <Button type="primary" @click="init">查询</Button>
                </Form-item>
                <Form-item>
                    <Button type="primary" @click="pushFn">新建项目</Button>
                </Form-item>
            </Form>
            <Table border :columns="columns" :data="data"></Table>
            <div class="clearfix page">
                <Page :total="pageTotal" class="fr" @on-change="pageChange" @on-page-size-change="pageSize" :current="formItem.start+1" placement="top" show-elevator show-sizer></Page>
            </div>
            <el-dialog title="删除" :visible.sync="deleteShow">
                <p>确定要删除模板？</p>
                <div slot="footer" class="dialog-footer">
                    <Button @click="deleteShow=false">取 消</Button>
                    <Button type="primary" @click="deleteFn">确 定</Button>
                </div>
            </el-dialog>
        </div>
        <router-view></router-view>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    export default {
        data(){
        	return{
        		formItem: {
                    name:'',
                    start:0,
                    length:10,
                },
                temid:'',
                columns:[
                    {
                        title: '项目名称',
                        key: 'bigname'
                    },{
                        title: '模板名称',
                        key: 'name'
                    },{
                        title: '创建人',
                        key: 'username'
                    },{
                        title: '创建时间',
                        key: 'cdate'
                    },{
                        title: '操作',
                        width: 140,
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small'
                                    },
                                    on: {
                                        click: () => {
                                            this.$router.push({path:'/projectList/taskList',query:{bigid:params.row.bigid}});
                                        }
                                    }
                                }, '查看'),
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small'
                                    },
                                    on: {
                                        click: () => {
                                            this.$router.push({path:'/projectList/projectTable',query:{bigid:params.row.bigid}});
                                        }
                                    }
                                }, '报表'),
                            ]);
                        }
                    }
                ],
                data:[],
                pageTotal:0,
                deleteShow:false,
        	}
        },
        watch:{
            $route(to,from){
                if(to.path == '/projectList'){
                    this.$store.dispatch('parentShowFn');
                    this.getData();
                }
            }
        },
        computed: {
            parentShow () {
                return this.$store.state.parentShow;
            }
        },
        created(){
            this.$store.dispatch('parentShowFn');
            this.getData();
        },
        methods:{
            pushFn(){
                this.$router.push({path:'/projectList/addProject'});
            },
            deleteFn(){
                this.deleteShow=false;
                var _this=this;
                this.$http.get('/web/template/deleteTemplate',{
                    params:{
                        temid:_this.temid
                    }
                }).then(function(res){
                    if(res.success){
                        _this.$Notice.success({
                            title:'删除模板',
                            desc:res.message
                        });
                        _this.getData();
                    }else{
                        _this.$Notice.error({
                            title:'删除模板',
                            desc:res.message
                        });
                    }
                }).catch(function(res){
                    _this.$Notice.error({
                        title:'删除模板',
                        desc:'数据请求失败'
                    });
                })
            },
            getData(){
                var _this=this;
                this.$http.get('/web/workorder/getBigWorkorderList',{
                    params:_this.formItem
                }).then(function(res){
                    _this.data=res.data;
                    _this.pageTotal=res.recordsTotal;
                    _this.$Message.success('加载成功');
                }).catch(function(res){
                    _this.$Message.error('加载失败');
                })
            },
            pageChange(res){
                this.formItem.start=res-1;
                this.getData();
            },
            pageSize(res){
                this.formItem.length=res;
                this.getData();
            },
            init(){
                this.formItem.start=0;
                this.getData();
            },
        }
    }
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/task/projectList.vue